import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './LogoGovbr.module.less';

const LogoGovbr = ({
  'title-id': id,
  title,
  invert = false,
  width,
  height,
  className,
}) => {
  const classes = cx(
    {
      [styles.logo]: !invert,
      [styles.invert]: invert,
    },
    className,
  );

  const size = {};
  if (width) {
    size.width = width;
  }
  if (height) {
    size.height = height;
  }

  return (
    <>
      <svg
        aria-labelledby={id}
        role="img"
        className={classes}
        xmlns="http://www.w3.org/2000/svg"
        width="578.496"
        height="208.313"
        viewBox="0 0 578.496 208.313"
        style={size}
      >
        <title id={id}>{title}</title>
        <g transform="translate(-14.33 -14.24)">
          <path
            d="M76.305,128.937c13.788,0,24.765-11.626,24.765-28.841,0-12.491-7.334-26.479-24.765-26.479-14.405,0-21.955,12.707-21.955,27.992C54.35,119.04,64.679,128.937,76.305,128.937ZM138.512,145.5c0,46.057-22.372,60.91-67.58,60.91a130.633,130.633,0,0,1-42.83-7.1l1.93-30.571C41.89,174.561,51.787,178,67.921,178c22.388,0,34.446-10.545,34.446-32.5v-6.037h-.432c-9.264,13.124-22.171,19.161-37.673,19.161-30.787,0-49.932-23.237-49.932-56.386,0-33.381,15.7-58.331,50.581-58.331,16.567,0,29.907,9.048,38.09,22.82h.448V46.5h35.079v99Z"
            transform="translate(0 16.14)"
            fill="#2864ae"
          />
          <path
            d="M210.252,157.389H253.36L293.889,45.93H256.232L233.35,125.321h-.417L210.252,45.93H169.63Z"
            transform="translate(84.479 17.239)"
            fill="#46ad44"
          />
          <path
            d="M184.973,102.612c0-16.675-7.272-31.435-25.028-31.435-17.74,0-25.012,14.76-25.012,31.435,0,16.459,7.272,31.219,25.012,31.219C177.7,133.831,184.973,119.071,184.973,102.612Zm-89.813,0c0-36.994,28.008-58.362,64.785-58.362s64.785,21.384,64.785,58.362c0,36.777-28.008,58.162-64.785,58.162C123.183,160.774,95.16,139.39,95.16,102.612Z"
            transform="translate(43.969 16.325)"
            fill="#fabd10"
          />
          <path
            d="M265.806,114.361A18.273,18.273,0,1,1,247.525,96.08,18.262,18.262,0,0,1,265.806,114.361Z"
            transform="translate(116.916 44.519)"
            fill="#2864ae"
          />
          <path
            d="M317.217,90.173c-14.112,0-23.53,12.4-23.53,29.073,0,16.258,10.7,28.455,23.53,28.455,14.544,0,23.314-12.2,23.314-29.953C340.531,103,332.193,90.173,317.217,90.173ZM255.2,14.24H293.9V77.558h.432c9.851-12.414,22.882-16.891,38.291-16.891,30.8,0,47.678,29.289,47.678,56.247,0,32.933-17.74,60.323-50.9,60.323-17.756,0-33.365-10.051-38.275-22.465h-.432v19.9H255.18V14.24Z"
            transform="translate(131.016 0)"
            fill="#2864ae"
          />
          <path
            d="M415.791,77.665c-4.277-1.281-8.554-1.281-13.047-1.281-17.972,0-28.008,13.047-28.008,34.863v47.06H336.23V46.863h35.079V67.4h.432C378.38,53.27,388,44.3,404.674,44.3a80.869,80.869,0,0,1,13.047,1.282Z"
            transform="translate(175.105 16.352)"
            fill="#fabd10"
          />
        </g>
      </svg>
    </>
  );
};

LogoGovbr.propTypes = {
  'title-id': PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  invert: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default LogoGovbr;
